var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
__name(_typeof, "_typeof");
var _excluded = ["selectedFrame"];
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
__name(_defineProperty, "_defineProperty");
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
__name(_toPropertyKey, "_toPropertyKey");
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
__name(_toPrimitive, "_toPrimitive");
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o, r, i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
__name(_objectWithoutProperties, "_objectWithoutProperties");
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
__name(_objectWithoutPropertiesLoose, "_objectWithoutPropertiesLoose");
import React from "react";
import classNames from "classnames";
import { Button, Heading, Link, Hint, PicturePlaceholder, Counter } from "@riseart/common";
import { DeleteIcon } from "@riseart/icons";
import { ArtOptionFrame, ArtOptionLabel, ArtOptionSingle } from "@riseart/art";
import { cartItemCls, cartItemStyleMainCls, cartItemStyleSidebarCls, cartItemStyleCheckoutCls, cartItemControlsCls, cartItemControlsSeparatorCls, cartItemMediaCls, cartItemContentCls, cartItemContentMainCls, cartItemContentMainPaddedCls, cartItemHeadingsCls, cartItemTitleCls, cartItemAuthorCls, cartItemDetailsCls, cartItemPriceCls, cartItemDiscountCls, cartItemOptionsCls, cartItemOptionsRowCls, cartItemAdditionalCls } from "./Item.less";
var DISPLAY_SETTINGS = {
  main: {
    className: cartItemStyleMainCls,
    showDelete: true,
    showWishlist: true,
    showAdditionalInfo: true,
    showFrameControls: true,
    showFrameText: false,
    showQtyControls: true,
    showQtyText: false,
    showDiscount: true,
    editInsurance: true,
    disableHint: false,
    disableLinks: false
  },
  sidebar: {
    className: cartItemStyleSidebarCls,
    showDelete: true,
    showWishlist: false,
    showAdditionalInfo: false,
    showFrameControls: true,
    showFrameText: true,
    showQtyControls: false,
    showQtyText: true,
    showDiscount: false,
    editInsurance: true,
    disableHint: false,
    disableLinks: false
  },
  checkout: {
    className: cartItemStyleCheckoutCls,
    showDelete: false,
    showWishlist: false,
    showAdditionalInfo: true,
    showFrameControls: true,
    showFrameText: true,
    showQtyControls: false,
    showQtyText: true,
    showDiscount: false,
    editInsurance: false,
    disableHint: true,
    disableLinks: true
  },
  review: {
    className: cartItemStyleMainCls,
    showDelete: false,
    showWishlist: false,
    showAdditionalInfo: true,
    showFrameControls: true,
    showFrameText: true,
    showQtyControls: false,
    showQtyText: true,
    showDiscount: true,
    editInsurance: false,
    disableHint: true,
    disableLinks: false
  }
};
function CartItem(_ref) {
  var _ref$displayStyle = _ref.displayStyle, displayStyle = _ref$displayStyle === void 0 ? "main" : _ref$displayStyle, title = _ref.title, url = _ref.url, details = _ref.details, price = _ref.price, _ref$discount = _ref.discount, discount = _ref$discount === void 0 ? null : _ref$discount, additional = _ref.additional, artistName = _ref.artistName, artistUrl = _ref.artistUrl, rentalDuration = _ref.rentalDuration, _ref$favoriteButton = _ref.favoriteButton, favoriteButton = _ref$favoriteButton === void 0 ? null : _ref$favoriteButton, onInsuranceChange = _ref.onInsuranceChange, onFrameSelect = _ref.onFrameSelect, onDelete = _ref.onDelete, onCountUpdate = _ref.onCountUpdate, pictureProps = _ref.pictureProps, currencySign = _ref.currencySign, _ref$frameOptions = _ref.frameOptions, selectedFrame = _ref$frameOptions.selectedFrame, frameOptions = _objectWithoutProperties(_ref$frameOptions, _excluded), qty = _ref.qty, allowQtyChange = _ref.allowQtyChange, translations = _ref.translations, frameLabelRenderer = _ref.frameLabelRenderer, insurance = _ref.insurance;
  var _ref2 = displayStyle && DISPLAY_SETTINGS[displayStyle] || DISPLAY_SETTINGS.main, cartStyleClassName = _ref2.className, showDelete = _ref2.showDelete, showWishlist = _ref2.showWishlist, showAdditionalInfo = _ref2.showAdditionalInfo, showFrameControls = _ref2.showFrameControls, showFrameText = _ref2.showFrameText, showQtyControls = _ref2.showQtyControls, showQtyText = _ref2.showQtyText, showDiscount = _ref2.showDiscount, disableHint = _ref2.disableHint, disableLinks = _ref2.disableLinks, editInsurance = _ref2.editInsurance;
  return /* @__PURE__ */ React.createElement("div", {
    className: classNames(cartItemCls, cartStyleClassName)
  }, /* @__PURE__ */ React.createElement("div", {
    className: cartItemMediaCls
  }, disableLinks || !url ? /* @__PURE__ */ React.createElement(PicturePlaceholder, pictureProps) : /* @__PURE__ */ React.createElement(Link, {
    to: url,
    title
  }, /* @__PURE__ */ React.createElement(PicturePlaceholder, pictureProps))), /* @__PURE__ */ React.createElement("div", {
    className: cartItemContentCls
  }, showWishlist || showDelete ? /* @__PURE__ */ React.createElement("div", {
    className: cartItemControlsCls
  }, showWishlist && favoriteButton ? favoriteButton : null, showDelete && showWishlist ? /* @__PURE__ */ React.createElement("span", {
    className: cartItemControlsSeparatorCls
  }) : null, showDelete ? /* @__PURE__ */ React.createElement(Button, {
    icon: /* @__PURE__ */ React.createElement(DeleteIcon, null),
    type: "link",
    linkType: "light",
    onClick: onDelete
  }) : null) : null, /* @__PURE__ */ React.createElement("div", {
    className: classNames(cartItemContentMainCls, _defineProperty({}, cartItemContentMainPaddedCls, showWishlist || showDelete))
  }, /* @__PURE__ */ React.createElement("div", {
    className: cartItemHeadingsCls
  }, /* @__PURE__ */ React.createElement(Heading, {
    tag: "h3",
    level: "5",
    className: cartItemTitleCls
  }, disableLinks || !url ? title : /* @__PURE__ */ React.createElement(Link, {
    to: url,
    title
  }, title)), artistName ? /* @__PURE__ */ React.createElement(Heading, {
    tag: "h4",
    level: "6",
    className: cartItemAuthorCls
  }, " ", translations.by, " ", disableLinks || !artistUrl ? artistName : /* @__PURE__ */ React.createElement(Link, {
    to: artistUrl,
    title: artistName
  }, artistName)) : null), details ? /* @__PURE__ */ React.createElement("div", {
    className: cartItemDetailsCls
  }, details) : null, price || rentalDuration ? /* @__PURE__ */ React.createElement("div", {
    className: cartItemPriceCls
  }, price, rentalDuration, showDiscount && discount ? /* @__PURE__ */ React.createElement("span", {
    className: cartItemDiscountCls
  }, discount) : null) : null), insurance && insurance.selected && !editInsurance ? /* @__PURE__ */ React.createElement("div", {
    className: cartItemOptionsCls
  }, insurance.title, " (", insurance.value && insurance.value.priceLabel, ")") : null, /* @__PURE__ */ React.createElement("div", {
    className: cartItemOptionsCls
  }, insurance && editInsurance ? /* @__PURE__ */ React.createElement("div", {
    className: cartItemOptionsRowCls
  }, /* @__PURE__ */ React.createElement(ArtOptionSingle, {
    actionLabel: insurance.actionLabel,
    title: insurance.title,
    hint: !disableHint && insurance.hint,
    price: insurance.value && insurance.value.priceLabel,
    link: insurance.value ? /* @__PURE__ */ React.createElement(Button, {
      type: "link",
      onClick: onInsuranceChange
    }, insurance.value.selected ? "- " : "+ ", translations[insurance.value.selected ? "remove" : "apply"]) : null
  })) : null, showFrameControls ? /* @__PURE__ */ React.createElement("div", {
    className: cartItemOptionsRowCls
  }, /* @__PURE__ */ React.createElement(ArtOptionFrame, {
    readOnly: showFrameText,
    disableHint,
    options: frameOptions,
    selectedFrameId: selectedFrame && selectedFrame.id,
    onFrameChange: onFrameSelect,
    translations: translations.frames,
    currencySign,
    hint: Hint,
    hintOptions: {
      placement: "N"
    },
    frameLabelRenderer
  })) : null, /* @__PURE__ */ React.createElement("div", {
    className: cartItemOptionsRowCls
  }, qty ? /* @__PURE__ */ React.createElement(ArtOptionLabel, {
    uppercase: !showQtyText
  }, translations.qty, showQtyText || !allowQtyChange ? ": ".concat(qty) : null) : null, showQtyControls && allowQtyChange ? /* @__PURE__ */ React.createElement(Counter, {
    min: 0,
    initial: qty,
    onIncrement: onCountUpdate,
    onDecrement: onCountUpdate
  }) : null)), showAdditionalInfo ? /* @__PURE__ */ React.createElement("div", {
    className: cartItemAdditionalCls
  }, additional) : null));
}
__name(CartItem, "CartItem");
export {
  CartItem
};
